var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.407 1.0954C14.007 0.409649 13.2943 0 12.5004 0C11.7065 0 10.9937 0.409436 10.5934 1.0954L0.304155 18.7376C-0.0988799 19.4289 -0.101442 20.2557 0.2969 20.9493C0.695456 21.6431 1.41087 22.0572 2.21094 22.0572H22.789C23.5893 22.0572 24.3047 21.6433 24.703 20.9493C25.1016 20.2557 25.0988 19.4289 24.6958 18.7376L14.407 1.0954ZM13.682 9.98205L13.2504 14.2789C13.2114 14.6655 12.889 14.9572 12.5005 14.9572C12.112 14.9572 11.7893 14.6653 11.7505 14.2789L11.3189 9.98205C11.2784 9.57966 11.2579 9.17106 11.2579 8.76698V7.63853C11.2579 7.31956 11.5176 7.05989 11.8361 7.05989H13.1647C13.4834 7.05989 13.7429 7.31955 13.7429 7.63853V8.76698C13.7431 9.17108 13.7228 9.5801 13.682 9.98205ZM13.7431 17.678C13.7431 18.3633 13.1858 18.9206 12.5005 18.9206C11.8151 18.9206 11.2579 18.3633 11.2579 17.678C11.2579 16.9927 11.8151 16.4352 12.5005 16.4352C13.1858 16.4352 13.7431 16.9927 13.7431 17.678Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.797280af17fa3c398fb97e58fac47e83.svg";